// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffcommon/v1/eex_service.proto (package bffcommon.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_acl_v1_acl } from "../../acl/v1/acl_pb";
import type { Contract } from "./eex_model_pb";
import { file_bffcommon_v1_eex_model } from "./eex_model_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffcommon/v1/eex_service.proto.
 */
export const file_bffcommon_v1_eex_service: GenFile = /*@__PURE__*/
  fileDesc("Ch5iZmZjb21tb24vdjEvZWV4X3NlcnZpY2UucHJvdG8SDGJmZmNvbW1vbi52MSIWChRMaXN0Q29udHJhY3RzUmVxdWVzdCJCChVMaXN0Q29udHJhY3RzUmVzcG9uc2USKQoJY29udHJhY3RzGAEgAygLMhYuYmZmY29tbW9uLnYxLkNvbnRyYWN0MssCCgpFRVhTZXJ2aWNlErwCCg1MaXN0Q29udHJhY3RzEiIuYmZmY29tbW9uLnYxLkxpc3RDb250cmFjdHNSZXF1ZXN0GiMuYmZmY29tbW9uLnYxLkxpc3RDb250cmFjdHNSZXNwb25zZSLhAZqQG9wBChNlY2xlYXItYmFzaWMtbWFzdGVyChRlY2xlYXItYmFzaWMtZGVmYXVsdAoVZWNsZWFyLWJyb2tlci1kZWZhdWx0ChRlY2xlYXItYnJva2VyLW1hc3RlcgocZWNsZWFyLWludGVybmFsX29wcy1hcHByb3ZlcgobZWNsZWFyLWludGVybmFsX29wcy1kZWZhdWx0ChplY2xlYXItaW50ZXJuYWxfb3BzLW1hc3RlcgoVZW5naW5lLWJyb2tlci1kZWZhdWx0ChRlbmdpbmUtYnJva2VyLW1hc3RlckLAAQoQY29tLmJmZmNvbW1vbi52MUIPRWV4U2VydmljZVByb3RvUAFaSmdpdGh1Yi5jb20vZW5lY2hhaW4vZXBvc2l0aW9uLWFwcC9iYWNrZW5kL2dlbi9wcm90by9iZmZjb21tb24vdjE7YmZmY29tbW9uogIDQlhYqgIMQmZmY29tbW9uLlYxygIMQmZmY29tbW9uXFYx4gIYQmZmY29tbW9uXFYxXEdQQk1ldGFkYXRh6gINQmZmY29tbW9uOjpWMWIGcHJvdG8z", [file_acl_v1_acl, file_bffcommon_v1_eex_model]);

/**
 * @generated from message bffcommon.v1.ListContractsRequest
 */
export type ListContractsRequest = Message<"bffcommon.v1.ListContractsRequest"> & {
};

/**
 * Describes the message bffcommon.v1.ListContractsRequest.
 * Use `create(ListContractsRequestSchema)` to create a new message.
 */
export const ListContractsRequestSchema: GenMessage<ListContractsRequest> = /*@__PURE__*/
  messageDesc(file_bffcommon_v1_eex_service, 0);

/**
 * @generated from message bffcommon.v1.ListContractsResponse
 */
export type ListContractsResponse = Message<"bffcommon.v1.ListContractsResponse"> & {
  /**
   * @generated from field: repeated bffcommon.v1.Contract contracts = 1;
   */
  contracts: Contract[];
};

/**
 * Describes the message bffcommon.v1.ListContractsResponse.
 * Use `create(ListContractsResponseSchema)` to create a new message.
 */
export const ListContractsResponseSchema: GenMessage<ListContractsResponse> = /*@__PURE__*/
  messageDesc(file_bffcommon_v1_eex_service, 1);

/**
 * @generated from service bffcommon.v1.EEXService
 */
export const EEXService: GenService<{
  /**
   * @generated from rpc bffcommon.v1.EEXService.ListContracts
   */
  listContracts: {
    methodKind: "unary";
    input: typeof ListContractsRequestSchema;
    output: typeof ListContractsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffcommon_v1_eex_service, 0);

